import Link from 'next/link';
import { useRouter } from 'next/router';
import { UrlObject } from 'url';
import { ReactNode } from 'react';
import { ArticleTagItem, ArticleTagsList } from './styles';

export interface IPathArticle {
  label: string;
  display_all: boolean;
}

export interface IArticleMenuProps {
  paths: IPathArticle[];
}

export interface IArticleMenuItem {
  tag?: string;
  children?: ReactNode;
}

export const ArticleTagMenu = ({ paths }: IArticleMenuProps) => {
  return (
    <ArticleTagsList>
      <ArticleTagMenuItem key={'item'}>{'All articles'}</ArticleTagMenuItem>
      {paths.map((item: any) => {
        return (
          <ArticleTagMenuItem key={item} tag={item}>
            {item}
          </ArticleTagMenuItem>
        );
      })}
    </ArticleTagsList>
  );
};

const ArticleTagMenuItem = ({ tag, children }: IArticleMenuItem) => {
  const { query } = useRouter();
  const itemHref: UrlObject = {
    pathname: tag ? `/insights/tag/${tag}` : '/insights',
  };

  return (
    <Link href={itemHref} legacyBehavior>
      <ArticleTagItem isActive={query?.tag === tag}>{children}</ArticleTagItem>
    </Link>
  );
};
